import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent {
  checked = false;
  constructor(
    private _activeModal: NgbActiveModal,
    private _router: Router
  ) { }

  close() {
    localStorage.setItem('popupNewBiogas-6', JSON.stringify(this.checked));
    this._activeModal.close(true);
  }

  jupiter() {
    this._activeModal.close(true);
    this._router.navigate(['/jupiter']);
  }
}
